import React, { Component } from "react";

class Main extends Component {
  constructor(props) {
    super(props);
    this.main = React.createRef();
  }

  static defaultProps = {
    bgc: "#fff",
    bgi: "none",
    className: "page",
    margin: "56px auto 0px",
    styles: {
      height: "100hw",
      width: "100%",
      maxWidth: "1200px",
      color: "#444",
      fontSize: "16px",
      lineHeight: "24px",
      fontFamily: "Roboto, sans-serif",
      textTransform: "none",
      border: "0px dashed #cc00cc",
      padding: "0",
    },
    children: "Main Content",
  };

  render() {
    return (
      <main
        className={this.props.className}
        id="main"
        ref={this.main}
        style={{
          backgroundColor: this.props.bgc,
          margin: "56px auto 0px",
          ...this.props.styles,
        }}
      >
        {this.props.children}
      </main>
    );
  }
}

export default Main;
